export const initialState = {
  token: null,
  type: null,
  targetLink: null,
  raisid: null,
};
